import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export type OrgLoginProps = {
  orgs: string[];
};

const DEFAULT_ORGANIZATION = 'demo_bess';

export function AutoOrgLogin({ orgs }: OrgLoginProps) {
  const auth0 = useAuth0();
  const location = useLocation();

  useEffect(
    function () {
      const defaultOrganization = orgs.includes(DEFAULT_ORGANIZATION)
        ? DEFAULT_ORGANIZATION
        : orgs[0];

      auth0.loginWithRedirect({
        appState: {
          returnTo: location.pathname,
        },
        authorizationParams: {
          organization: defaultOrganization,
        },
      });
    },
    [auth0, location.pathname, orgs],
  );

  return null;
}
